import { ICourse, ISection } from '../../interfaces/scheduler_interfaces';

class CourseMissingRequisitesController {
  private course: ICourse;
  private section: ISection;
  init() {
    this.course = this.section._course;
  }
  $onChanges() {
    this.init();
  }
  $onInit() {
    this.init();
  }
}
angular.module('capability-ng-scheduler').component('courseMissingRequisites', {
  templateUrl: 'capability-ng-scheduler/src/components/course_missing_requisites/course_missing_requisites.html',
  bindings: {
    section: '<'
  },
  controller: CourseMissingRequisitesController
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/course_missing_requisites/course_missing_requisites.ts